import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBell"><Path d="M12 2C7.79219 2 4.19827 5.17264 3.75 9.35647L2.98616 14.3328C2.7305 15.9983 4.01927 17.5 5.70432 17.5H18.2957C19.9807 17.5 21.2695 15.9983 21.0138 14.3328L20.25 9.35648C19.8017 5.17264 16.2077 2 12 2Z" fill="currentColor"/><Path d="M16.5839 19H7.41601C8.18757 20.7659 9.94965 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell;
